import articleDeliveryTypes from "../constants/articleDeliveryTypes";

export default function applyArticleDistributionChannelPresetData({ article, channel, preset }) {
	return {
		takedownDate: null,
		preventTakedown: channel.preventTakedown || false,
		deliveryTypes: article?.channels?.[channel.id]?.deliveryTypes ||
			preset?.deliveryTypes || [articleDeliveryTypes.ARTIFACT, articleDeliveryTypes.METADATA],
		countries: article?.channels?.[channel.id]?.countries || preset?.targetData?.countries || [],
		prices: article?.channels?.[channel.id]?.prices || preset?.targetData?.prices || [],
		subChannels: article?.channels?.[channel.id]?.subChannels || preset?.targetData?.subChannels || [],
	};
}
